module.exports = __webpack_public_path__ + "img/34.2c6acc3a.svg";